import { Component, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { QuestBlockModalComponent } from './partials/quest-block-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AlertService } from '../alerts/alert.service';
import { TranslationService } from '../services/translation.service';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { QuestblocksService } from '../services/questblocks.service';
import { PermissionsService } from '../services/permissions.service';

@Component({
  selector: 'app-manage-quest-blocks',
  templateUrl: 'manage-quest-blocks.component.html'
})
export class ManageQuestBlocksComponent implements OnInit, OnDestroy {
  dataSource = new MatTableDataSource();
  displayedColumns = ['Status', 'Title', 'QuestBlockKey', 'CreatedOn', 'ProductionFlag', 'AlignedResponseCount', 'UnalignedResponseCount', 'rumbles_groups_count', 'Edit'];
  bsModalRef: BsModalRef;
  bsConfig: Partial<BsDatepickerConfig>;
  public translations: any = {};
  public permissions = [];
  public questBlocksLoading = false;
  private modalSubscription: EventEmitter<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private modalService: BsModalService,
    private _localeService: BsLocaleService,
    private translationService: TranslationService,
    private questBlocksService: QuestblocksService,
    private alertService: AlertService,
    private permissionService: PermissionsService
  ) {
    this.translations = translationService.getTranslations();
    this.permissions = this.permissionService.getPermissions();
    this._localeService.use('en-gb');
    this.bsConfig = Object.assign({}, { containerClass: 'theme-blue' });
  }

  ngOnInit() {
    this.questBlocksLoading = true;
    this.refresh();
    this.modalSubscription = this.modalService.onHide.subscribe(() => this.refresh()); // refresh on close modal
  }

  ngOnDestroy() {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }

  refresh() {
    this.questBlocksService.getQuestBlocks()
      .then(questBlocks => {
        this.dataSource = new MatTableDataSource(questBlocks);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.questBlocksLoading = false;
      })
      .catch((msg) => {
        console.log(msg);
        this.questBlocksLoading = false;
        this.alertService.show(msg.error.message, 'danger');
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  openDialog(questBlockObject: object, type: string) {
    const componentType = QuestBlockModalComponent;
    const initialState: any = {
      data: {
        questBlockObject: {
          Title: '',
          ProductionFlag: 1,
          Comment: '',
          rumbles_groups: []
        }
      },
      type: type,
      title: 'Manage Quest Block'
    };

    if (type === 'edit') {
      initialState.title = 'Edit Quest Block';
      initialState.data.questBlockObject = questBlockObject;
    } else if (type === 'add') {
      initialState.title = 'Add Quest Block';
    }

    this.bsModalRef = this.modalService.show(componentType, {initialState, class: 'modal-lg'});
    this.bsModalRef.content.closeBtnName = 'Close';
  }
}

